'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Credential(id, kind, name, username, hash, inherited, created, expires) {
  this.mZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.j8 = null;
  this.fx = null;
  this.kX = null;
  this.f0 = null;
  this.KS = false;
  this.DB = null;
  this.xc = null;
  this.mZ = id;
  this.j8 = kind;
  this.fx = name;
  this.kX = username;
  this.f0 = hash;
  this.KS = inherited;
  this.DB = created;
  this.xc = expires;
}
export { $c_Lpresto_types$Credential as $c_Lpresto_types$Credential };
$p = $c_Lpresto_types$Credential.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Credential;
/** @constructor */
function $h_Lpresto_types$Credential() {
}
export { $h_Lpresto_types$Credential as $h_Lpresto_types$Credential };
$h_Lpresto_types$Credential.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Credential"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.mZ;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.j8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.fx));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.kX));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.f0));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.KS ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DB));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xc));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 8);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Credential)) {
    if ((this.KS === x$0.KS)) {
      var this$1 = this.mZ;
      var b = x$0.mZ;
      var $x_3 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x = this.j8;
      var x$2 = x$0.j8;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if (((($x_2 && (this.fx === x$0.fx)) && (this.kX === x$0.kX)) && (this.f0 === x$0.f0))) {
      var x$3 = this.DB;
      var x$4 = x$0.DB;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.xc;
      var x$6 = x$0.xc;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 8;
});
$p.s = (function() {
  return "Credential";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.mZ;
      break;
    }
    case 1: {
      return this.j8;
      break;
    }
    case 2: {
      return this.fx;
      break;
    }
    case 3: {
      return this.kX;
      break;
    }
    case 4: {
      return this.f0;
      break;
    }
    case 5: {
      return this.KS;
      break;
    }
    case 6: {
      return this.DB;
      break;
    }
    case 7: {
      return this.xc;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.E = (function() {
  return this.fx;
});
$p.afU = (function() {
  return this.kX;
});
$p.H2 = (function() {
  return ("c#" + this.mZ);
});
$p.jW = (function() {
  return this.mZ;
});
function $isArrayOf_Lpresto_types$Credential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jy)));
}
export { $isArrayOf_Lpresto_types$Credential as $isArrayOf_Lpresto_types$Credential };
var $d_Lpresto_types$Credential = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Credential, "presto.types$Credential", ({
  jy: 1,
  aH: 1,
  jA: 1,
  ed: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Credential as $d_Lpresto_types$Credential };
//# sourceMappingURL=presto.types$-Credential.js.map
